<template>
    <a v-on:click="toggleWishlist(item)" class="uk-button uk-button-default uk-width-1-1">
        <span v-show="isInWishlist"><i class="fas fa-heart"></i></span>
        <span v-show="!isInWishlist"><i class="fal fa-heart"></i></span>
    </a>
</template>

<script>
    import Wishlist from "rubinred/wishlist/js/mixins/Wishlist";
    export default {
      mixins: [Wishlist],
      props: {
        item: {
          type: Object,
          required: true,
        },
      },
      data() {
        return {
          isInWishlist: {
            type: Boolean,
            default: false,
          }
        }
      },
      mounted() {
        this.isInWishlist = this.itemInWishlist(this.item);

        let self = this;
        window.App.$on('success.rr.wishlistAdd', () => {
          self.isInWishlist = self.itemInWishlist(self.item);
        });
        window.App.$on('success.rr.wishlistRemove', () => {
          self.isInWishlist = self.itemInWishlist(self.item);
        });
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/wishlist/assets/js/components/WishlistButton.vue